import { IError } from '@checkout/errors';
import * as React from 'react';
import { SvgIcon } from '..';
import * as Styles from './Messages.scss';

interface IOwnProps {
  type: 'error' | 'success';
  title: string;
  errors?: IError;
  onClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const Messages: React.SFC<IOwnProps> = ({ type, title, errors, onClick }) => {
  if (!errors) { return null; }

  return (
    <div className={Styles.messages}>
      <div className={Styles.icon}>
        <SvgIcon icon={type} />
      </div>
      <div className={Styles.title}>{title}</div>
      {errors.code && <div className={Styles.code}>Error code: {errors.code}</div>}
      {errors.title && <div className={Styles.name}>{errors.title}</div>}
      {errors && errors.messages && errors.messages.length > 0 && (
        <div className={Styles.messagesList}>
          {errors.messages.map((message) => {
            return <div className={Styles.message} key={message}>{message}</div>;
          })}
        </div>
      )}

      {errors.details && errors.details.stack && (
        <div className={Styles.messagesList}>
          <div className={Styles.message}>{errors.details.stack}</div>
        </div>
      )}

      {errors.message && (
        <div className={Styles.messagesList}>
          <div className={Styles.message}>{errors.message}</div>
        </div>
      )}

      <div className={Styles.buttonWrapper}>
        <button className={Styles.button} onClick={onClick}>OK, I got it</button>
      </div>
    </div>
  );
};

export default Messages;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Messages/Messages.tsx